import { render, staticRenderFns } from "./ReportSessionChannel.vue?vue&type=template&id=766f4810&"
import script from "./ReportSessionChannel.vue?vue&type=script&lang=js&"
export * from "./ReportSessionChannel.vue?vue&type=script&lang=js&"
import style0 from "./ReportSessionChannel.vue?vue&type=style&index=0&id=766f4810&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports